<!--
    The status chip. TEXT is always rendered — the state is never carried by colour alone
    (REV-21370 AC13, REV-21364 AC9).

    `data-state` is what the lab specs assert on: a class name is styling and may be renamed, a data
    attribute is the contract.
-->
<span
    class="adj-status"
    data-testid="adjustment-status"
    [attr.data-state]="state"
    [attr.data-tone]="tone"
    [attr.data-size]="size"
    [hamTooltip]="hintKey | i18next"
    tooltipClass="abcp"
>
    <span class="adj-status__dot" aria-hidden="true"></span>
    <span class="adj-status__label">{{ labelKey | i18next }}{{ yearSuffix }}</span>
</span>

<!--
    The ambiguity marking — a SECOND badge, not a fourth state (ADR-0015 §4).

    The correction really is `Übertragen`; it additionally has a question the user has to answer on the
    detail surface. Folding the two into one chip would lose the state, and hiding the question would
    leave a correction sitting unconfirmed with no explanation on screen.
-->
<span
    class="adj-status adj-status--ambiguous"
    data-testid="adjustment-ambiguous"
    [attr.data-size]="size"
    *ngIf="ambiguous"
    [hamTooltip]="'abcp_adjustments_ambiguous_hint' | i18next"
    tooltipClass="abcp"
>
    <span class="adj-status__label">{{ 'abcp_adjustments_ambiguous' | i18next }}</span>
</span>

<!--
    The NOT-FOUND marking — the other half of AC6, and a second badge for the same reason as the
    ambiguity one.

    Shown only when the row is not ALSO ambiguous. The backend already clears one when it writes the
    other, because they are contradictory answers; the guard here means a stale marker could never
    render as "not found" and "several candidates" at once.
-->
<span
    class="adj-status adj-status--not-found"
    data-testid="adjustment-not-found"
    [attr.data-size]="size"
    *ngIf="notFound && !ambiguous"
    [hamTooltip]="'abcp_adjustments_not_found_hint' | i18next"
    tooltipClass="abcp"
>
    <span class="adj-status__label">{{ 'abcp_adjustments_not_found' | i18next }}</span>
</span>
